// extracted by mini-css-extract-plugin
export default {"noAds":"MBp6h","image":"_2MDj4","title":"_2-0ot","subTitle":"xFCVT"};